import React from "react";
import "./CETDashBoard.css";
import { Col, Row } from "react-bootstrap";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import CETDashboardList from "./CETDashboardList";
import AddPartner from "../PartnerManagement/AddPartner/AddPartner";
import { Routes, Route, Navigate } from "react-router-dom";
import useWindowSize from "../../utils/useWindowSize";
import CETMobileHeader from "./CETMobileHeader";
import AccessManagement from "../AccessManagement/AccessManagement";
import CustomLogout from "./../CustomLogout/CustomLogout";
import { connect } from "react-redux";
import PartnerManagement from "../PartnerManagement/PartnerManagement";
import ModifyBankDetails from "../PartnerManagement/PartnerMenu/ModifyBankDetails";


// import EditPartner from "../PartnerManagement/EditPartner/EditPartner";

// const PartnerManagement = React.lazy(() =>
//   import("../PartnerManagement/PartnerManagement")
// );

const EditPartner = React.lazy(() =>
  import("../PartnerManagement/EditPartner/EditPartner")
);

const RedirectToGenerateReport = () => {
  return <Navigate to="/PartnerPayout/generate-report" replace />;
};

const routes = [
  {
    path: "/PartnerManagement",
    element: <PartnerManagement />,
  },
  {
    path: "/edit-partner",
    element: <EditPartner />,
  },
  {
    path: "/view-partner",
    element: <EditPartner />,
  },
  {
    path: "/modify-bank",
    element: <ModifyBankDetails />,
  },

  {
    path: "/AccessManagement",
    element: <AccessManagement />,
  },
  {
    path: "/Dashboard",
    element: <AccessManagement />,
  },
];

const CETDashboard = (props) => {
  const { width } = useWindowSize();
  return (
    <div>
      {props?.LogoutFlag?.logoutFlag ? <CustomLogout /> : ""}
      {width < 786 && (
        <Row>
          <Col lg={12} xs={12} md={12} sm={12} className="dashboard-cet-mobile">
            <CETMobileHeader />
          </Col>
        </Row>
      )}
      <Row>
        <Col lg={12} xs={12} md={12} sm={12} className="dashboard-content">
          <Col md={3} className="Left-side-blue">
            <CETDashboardList />
          </Col>

          <Col md={9} className="right-side-blue">
            <React.Suspense
              fallback={
                <div className="cet-dashobard-loader">
                  <Spin
                    className="cet-loader"
                    indicator={<LoadingOutlined style={{ color: "#00d8db" }} />}
                  ></Spin>
                </div>
              }
            >
              <Routes>
                {routes.map((route, index) => (
                  <Route
                    key={index}
                    path={route.path}
                    element={route.element}
                  />
                ))}
              </Routes>
            </React.Suspense>
          </Col>
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    LogoutFlag: state.Logout,
  };
};

export default connect(mapStateToProps)(CETDashboard);
